import { render, staticRenderFns } from "./addAdminModal.vue?vue&type=template&id=e1564c96"
import script from "./addAdminModal.vue?vue&type=script&lang=js"
export * from "./addAdminModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports